import { lazy } from 'react';

export const BncFraude = lazy(
    () => import(/* webpackChunkName: "animation_bnc-fraude" */ './BncFraude'),
);
export const BncFraudeHeader = lazy(
    () => import(/* webpackChunkName: "animation_bnc-fraude-header" */ './BncFraude/Header'),
);
export const TourismeLaurentidesPolaroid = lazy(
    () =>
        import(
            /* webpackChunkName: "animation_tourisme-laurentides-polaroid" */ './tourisme-laurentides/Polaroid'
        ),
);
export const Remax = lazy(() => import(/* webpackChunkName: "animation_remax" */ './Remax'));
export const JeuAideMachine = lazy(
    () => import(/* webpackChunkName: "animation_jeu-aide-machine" */ './jeu-aide-machine'),
);
export const SaqRouteProducteurs = lazy(
    () =>
        import(/* webpackChunkName: "animation_saq-route-producteurs" */ './saq-route-producteurs'),
);
export const TourismeMontrealVacances = lazy(
    () =>
        import(
            /* webpackChunkName: "animation_tourisme-montreal-vacances" */ './tourisme-montreal'
        ),
);
export const TourismeMontrealVacancesHeader = lazy(
    () =>
        import(
            /* webpackChunkName: "animation_tourisme-montreal-vacances-header" */ './tourisme-montreal/Header'
        ),
);
export const Fizz = lazy(() => import(/* webpackChunkName: "animation_fizz" */ './fizz'));
export const FizzHeader = lazy(
    () => import(/* webpackChunkName: "animation_fizz-header" */ './fizz/Header'),
);

export const Uniprix = lazy(() => import(/* webpackChunkName: "animation_uniprix" */ './uniprix'));

export const MesQuebec = lazy(
    () => import(/* webpackChunkName: "animation_mes-quebec" */ './mes-quebec'),
);

export const Sherbrooke = lazy(
    () => import(/* webpackChunkName: "animation_sherbrooke" */ './sherbrooke'),
);
export const SherbrookeHeader = lazy(
    () => import(/* webpackChunkName: "animation_sherbrooke-header" */ './sherbrooke/Header'),
);

export const Alto = lazy(() => import(/* webpackChunkName: "animation_alto" */ './alto'));

export const Educepargne = lazy(
    () => import(/* webpackChunkName: "animation_educepargne" */ './educepargne'),
);

export const EducepargneHeader = lazy(
    () => import(/* webpackChunkName: "animation_educepargne_header" */ './educepargne/Header'),
);

export const QuizTv5SerieHeader = lazy(
    () => import(/* webpackChunkName: "animation_tv5_header" */ './tv5/Header'),
);

export const Cfpbj = lazy(() => import(/* webpackChunkName: "animation_cfpbj" */ './cfpbj'));

export const QuizRetraiteQuebecFinancesHeader = lazy(
    () =>
        import(
            /* webpackChunkName: "animation_retraite-quebec-header" */ './retraite-quebec/Header'
        ),
);

export const QuizUniprixSanteAdulteHeader = lazy(
    () =>
        import(
            /* webpackChunkName: "animation_uniprix-sante-adulte-header" */ './uniprix-sante-adulte/Header'
        ),
);
